<template>
  <div class="home_page">
    <el-dialog
      :visible.sync="searchVisible"
      :close-on-click-modal='false'
      :before-close="cancelGoods"
      title="付款结果"
      width="800px"
    >
      <el-form
        :model="dataForm"
        :inline="true"
        ref="dataForm2"
        class="demo-form-inline"
        label-width="160px"
      >
        <el-row>
          <el-col :span="24">
            <div class="result">
              <div class="orderPay">
                <img
                  src="@/assets/img/order/success.png"
                  class="success"
                />
                <div class="pay-order">
                  订单支付成功
                  <div class="goOrder">现在您可以，<span
                      class="checkOrder"
                      @click="gotoOrder"
                    >查看我的订单</span></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <div class="container">
      <!-- 面包屑 -->
      <el-breadcrumb separator="/" style="line-height: 40px">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'orderList' }">订单列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="body-info">
        <el-form
          :model="dataForm"
          :inline="true"
          ref="dataForm"
          label-width="160px"
          class="demo-form-inline"
        >
          <el-row>
            <el-col :span="12">
              <h2>订单支付成功</h2>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div
                class="myorder"
                @click="gotoOrder"
              >查看我的订单>></div>
            </el-col>
          </el-row>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        check: '2'
      },
      searchVisible: true
    }
  },
  mounted () {},
  methods: {
    cancelGoods () {
      this.searchVisible = false
    },
    gotoOrder () {
      this.$router.push({ name: 'orderList' })
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.body-info {
  margin: 0 0 20px;
  width: 100%;
  padding: 30px 50px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
  h2 {
    font-size: 20px;
    color: #262626;
    margin-bottom: 20px;
  }
}

.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.btns {
  margin-left: 230px;
}
.btn-check {
  margin-right: 30px;
}
.myorder {
  color: #1d65a8;
  cursor: pointer;
}
.result {
  width: 800px;
  height: 321px;
  background: url("./../../../assets/img/order/bac.png");
  background-size: 800px 321px;
  margin-left: -20px;
  margin-bottom: -29px;
}
.orderPay {
  width: 100%;
  height: 80px;
}
.orderPay img {
  float: left;
}
.success {
  margin-left: 250px;
  width: 70px;
  height: 70px;
  margin-top: 50px;
}
.pay-order {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-top: 60px;
  float: left;
  margin-left: 30px;
}
.goOrder {
  font-weight: normal;
  margin-top: 10px;
  font-size: 14px;
}
.checkOrder {
  color: #1d65a8;
  cursor: pointer;
}
</style>
